module.exports = __webpack_public_path__ + "officialStatic/img/pseImg.ca3a94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/pseImg.png
// module id = yMeM
// module chunks = 0